function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".billing_svg__cls-1{fill:#f5f8fc}"));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "billing_svg__Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "billing_svg__Capa_6",
  "data-name": "Capa 6"
}, React.createElement("path", {
  className: "billing_svg__cls-1",
  d: "M27.48 0H3.76A3.75 3.75 0 000 3.75v17.5A3.76 3.76 0 003.76 25h23.72a3.75 3.75 0 003.75-3.76V3.75A3.74 3.74 0 0027.48 0zm1.7 20.83a2.09 2.09 0 01-2.09 2.09H4.14a2.09 2.09 0 01-2.08-2.09V12.5h27.11zm0-14.58H2.06V4.16a2.09 2.09 0 012.08-2.09h22.94a2.09 2.09 0 012.09 2.09zM10.61 20.83h4.16a1 1 0 100-2.08h-4.16a1 1 0 100 2.08zm-5.61 0h2.13a1 1 0 100-2.08H5a1 1 0 100 2.08z"
}), React.createElement("path", {
  className: "billing_svg__cls-1",
  d: "M8.17 19.79a1 1 0 01-1 1H5a1 1 0 110-2.08h2.13a1 1 0 011.04 1.08zM15.81 19.79a1 1 0 01-1 1h-4.2a1 1 0 110-2.08h4.16a1 1 0 011.04 1.08z"
}), React.createElement("path", {
  className: "billing_svg__cls-1",
  d: "M8.17 19.79a1 1 0 01-1 1H5a1 1 0 110-2.08h2.13a1 1 0 011.04 1.08zM15.81 19.79a1 1 0 01-1 1h-4.2a1 1 0 110-2.08h4.16a1 1 0 011.04 1.08z"
})));

var SvgBilling = function SvgBilling(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 31.22 25"
  }, props), _ref, _ref2);
};

export default SvgBilling;